<template>
  <div>
    <el-form
      :model="list"
      :rules="toAdRule"
      label-position="right"
      label-width="200px"
      ref="ruleForm"
      style="width: 90%; margin: 20px auto"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="名字" prop="name">
            <el-input placeholder="请输入内容" v-model="list.name" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="电话" prop="phone">
            <el-input placeholder="请输入内容" v-model="list.phone" clearable />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item
            prop="email"
            label="邮箱"
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-input v-model="list.email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="工作年限" prop="work">
            <el-input
              type="input"
              :rows="10"
              placeholder="请输入内容"
              v-model="list.work"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="头像(正方形图片)" prop="photoUrl" ref="photoUrl">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccess"
            >
              <img
                v-if="list.photoUrl"
                :src="list.photoUrl"
                class="avatar"
                style="width: 150px; height: auto"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="微信二维码" prop="wechat" ref="wechat">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="upSuccessWeChat"
            >
              <img
                v-if="list.wechat"
                :src="list.wechat"
                class="avatar"
                style="width: 150px; height: auto"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          style="margin-left: 200px"
          type="primary"
          @click="submitAdd('ruleForm')"
          >保存</el-button
        >
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  props: ["ChangeData"],
  data() {
    var valiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.photoUrl)
      if (this.list.photoUrl == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };
    var valiIcon2 = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.photoUrl)
      if (this.list.wechat == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false, //加载
      list: "",
      //留言类型--下拉框：
      type: [
        {
          value: 1,
          label: "最新开盘",
        },
        {
          value: 2,
          label: "热门楼盘",
        },
      ],
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      toAdRule: {
        name: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        work: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        price: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        phone: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        photoUrl: [{ required: true, validator: valiIcon, trigger: "blur" }],
        wechat: [{ required: true, validator: valiIcon2, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.list = this.ChangeData;
  },
  watch: {
    ChangeData(newVal, oldVal) {
      this.list = newVal;
    },
  },
  methods: {
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    // 头像
    upSuccess(file) {
      this.list.photoUrl = file.entity;
    },
    // 微信二维码
    upSuccessWeChat(file) {
      this.list.wechat = file.entity;
    },
    //新增专题：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/salesman/edit", {
            name: this.list.name, //名字
            photoUrl: this.list.photoUrl, //头像
            phone: this.list.phone, //手机号
            wechat: this.list.wechat, //内容
            email: this.list.email, //邮箱
            work: this.list.work, //工作年限
            id: this.list.id,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>